// @flow @jsx h
import { h } from 'preact'
import { PureComponent } from '../../lib/pureComponent'
import { EsiInclude } from './common/EsiInclude'
import type { PictureProps } from '../types'

type Props = {
  image: PictureProps,
  isDynamic?: boolean,
  dynamicBaseUrl?: string
}

export class Image extends PureComponent<Props, {}> {
  render() {
    const { image } = this.props
    const isDynamic = this.props.isDynamic ? this.props.isDynamic : false
    const dynamicBaseUrl = this.props.dynamicBaseUrl ? this.props.dynamicBaseUrl : ''
    const { id: imageId } = image
    const path = !isDynamic
      ? `/serum/render?id=${imageId}&size=10`
      : `${dynamicBaseUrl}/serum/api/render/${imageId}?size=10`
    return <EsiInclude path={path} isDynamic={isDynamic} />
  }
}



// WEBPACK FOOTER //
// ./src/v1/components/Image.js